import useActivity from "@/Common/CustomHooks/useActivity";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";

global.myleAppVersion = process.env.REACT_APP_VERSION.split("-")[0]; // remove potential suffix for feature releases

async function getServerVersion(): Promise<string | null> {
    try {
        const response = await fetch(apiSettings.buildAppUrl("api/public/health.json"));
        const data = await response.json();
        return data.ApiVersion;
    }
    catch (error) {
        console.error("Failed to fetch version:", error);
        return null;
    }
}

async function verifyVersion(): Promise<void> {
    if (!/^\d+\.\d+\.\d{4}\.\d{4}$/.test(global.myleAppVersion))
        return;

    const latestVersion = await getServerVersion();

    if (latestVersion && latestVersion !== global.myleAppVersion) {
        MyleHelper.reloadApp(latestVersion, 60000);
    }
}

function VersionCheck(): JSX.Element {
    useActivity(verifyVersion, verifyVersion, 2 * 60000, 10 * 60000, 10000);

    return null;
}

export { VersionCheck };
